<template>
  <div class="page-wrapper">
    <div class="app-card-lg policy-card">
      <h1 class="policy-title">用户隐私政策</h1>
      <div class="policy-content">
        <p>更新时间：2026年9月11日</p>
        <p>生效时间：2026年9月11日</p>
        <p>
          <strong>【重要提示】</strong>
          请您在使用「EATing创意融合轻食」相关服务（含微信小程序、网站及相关配套系统，以下统称“本服务”）前，仔细阅读并充分理解本《用户隐私政策》（以下简称“本政策”）。
          您点击同意、注册、登录或以其他方式使用本服务，即表示您已阅读并同意本政策。
        </p>

        <h2>一、信息处理主体与角色说明</h2>
        <ul>
          <li>
            <strong>实际运营方（个人信息处理主要责任方）：</strong>
            温岭市城西宜汀餐饮店（个体工商户）（对外品牌名称：EATing创意融合轻食，以下简称“运营方”）。
            运营方负责门店日常经营、商品与服务提供、订单履约、客户服务、营销活动及与用户之间的交易关系。
          </li>
          <li>
            <strong>开发与技术支持单位（受托技术处理方）：</strong>
            温岭市太平迅驰软件开发工作室（个体工商户）（以下简称“开发单位”或“技术支持方”）。
            开发单位仅提供软件开发、系统技术支持与维护服务，不参与门店日常运营，不作为餐饮服务提供者，不作为与您发生餐品交易的相对方，亦不参与经营决策、商品定价、配送履约及资金结算。
          </li>
          <li>
            本政策适用于运营方通过本服务向用户提供的功能，以及开发单位在运营方授权范围内为保障系统运行所进行的必要技术处理。
          </li>
        </ul>

        <h2>二、我们收集哪些个人信息</h2>
        <p>为实现本服务功能，运营方可能收集下列信息（具体以实际使用功能为准）：</p>

        <h3>（一）账号与身份信息</h3>
        <ul>
          <li>微信 OpenID/UnionID 等标识、昵称、头像、手机号码、登录凭证、会员等级与积分相关信息等。</li>
          <li>用途：注册登录、身份识别、账号安全、会员服务与客服沟通。</li>
        </ul>

        <h3>（二）订单与交易信息</h3>
        <ul>
          <li>
            商品信息、规格与数量、订单金额、下单时间、订单状态、取餐/配送方式、随心订周期与餐次、订单延期记录、兑换券/团购券核销与使用记录、备注信息等。
          </li>
          <li>用途：生成与履约订单、售后处理、对账审计、风控与纠纷处理。</li>
        </ul>

        <h3>（三）收货与配送信息</h3>
        <ul>
          <li>收货人姓名、联系电话、收货地址、定位相关信息（经您授权）、配送区域、配送备注等。</li>
          <li>
            用途：完成配送、联系收货人、处理异常订单。如您拒绝授权位置信息，可能无法展示与门店距离或影响部分地图相关功能，但不影响您浏览商品等基本功能。
          </li>
        </ul>

        <h3>（四）支付与退款信息</h3>
        <ul>
          <li>支付状态、支付时间、支付流水标识、退款状态与结果等。</li>
          <li>
            说明：银行卡号、支付密码、生物识别支付凭证等敏感信息由持牌支付机构（如微信支付等）依法处理，本服务不直接保存上述敏感支付凭据。
          </li>
        </ul>

        <h3>（五）设备、日志与安全信息</h3>
        <ul>
          <li>设备型号、操作系统版本、网络环境、访问日志、操作日志、错误日志、IP 地址等。</li>
          <li>用途：保障系统安全稳定、故障排查、体验优化、满足审计与合规要求。</li>
        </ul>

        <h3>（六）客服与反馈信息</h3>
        <ul>
          <li>您在客服沟通、投诉建议中主动提供的信息及沟通记录。</li>
          <li>用途：响应咨询、处理投诉、改进服务。</li>
        </ul>

        <h2>三、我们如何使用个人信息</h2>
        <ul>
          <li>完成账号注册登录、身份核验与安全保障；</li>
          <li>处理订餐、随心订、券码兑换/核销、支付、配送与售后；</li>
          <li>发送与订单履约相关的必要通知（如订单状态变更）；</li>
          <li>开展风控、反作弊、审计及故障排查；</li>
          <li>在取得您同意或法律允许的范围内改进产品体验；</li>
          <li>履行法律法规规定的义务。</li>
        </ul>
        <p>
          开发单位仅在提供开发、运维、技术支持所必需的范围内处理相关数据，且应运营方委托与授权进行，不得超出委托范围用于自身经营目的。
        </p>

        <h2>四、信息共享、转让与公开披露</h2>
        <ul>
          <li>我们不会出售您的个人信息。</li>
          <li>
            为实现支付、地图定位、消息通知、物流配送等功能，可能在最小必要范围内与相关服务提供方共享必要信息，并要求其依法保护您的信息安全。
          </li>
          <li>
            开发单位作为技术支持方，可能接触系统运行所需的数据，但其仅提供技术服务，不改变运营方作为信息处理主要责任方的地位。
          </li>
          <li>
            如发生合并、分立、资产转让等导致信息转移，将依法履行告知义务，并要求接收方继续保护您的信息。
          </li>
          <li>除法律法规另有规定或取得您的单独同意外，不会公开披露您的个人信息。</li>
        </ul>

        <h2>五、信息存储、安全与保留期限</h2>
        <ul>
          <li>个人信息原则上存储于中华人民共和国境内。</li>
          <li>采取合理可行的安全措施，包括但不限于访问控制、权限隔离、传输保护、备份与审计等。</li>
          <li>
            仅在实现处理目的所必需的最短期限内保存个人信息；超期后将依法删除或匿名化处理，法律法规另有规定的除外。
          </li>
        </ul>

        <h2>六、您的权利</h2>
        <ul>
          <li>查阅、复制、更正、补充个人信息；</li>
          <li>在符合法律规定条件下请求删除个人信息、撤回授权同意；</li>
          <li>申请注销账号（注销后部分交易记录可能依法保留）；</li>
          <li>对个人信息处理活动进行投诉、举报。</li>
        </ul>
        <p>您可通过本服务“我的-设置/客服”等入口，或通过本政策末尾联系方式联系运营方行使权利。</p>

        <h2>七、未成年人保护</h2>
        <ul>
          <li>本服务主要面向成年人。</li>
          <li>
            未成年人应在监护人同意与指导下使用。如我们发现在未经监护人同意的情况下收集了未成年人个人信息，将依法及时删除或采取其他保护措施。
          </li>
        </ul>

        <h2>八、第三方服务说明</h2>
        <p>
          本服务可能接入微信支付、地图定位、微信开放能力等第三方服务。第三方可能依据其自身隐私政策处理相关信息，建议您同时阅读第三方规则。开发单位不对第三方独立处理行为承担运营责任。
        </p>

        <h2>九、政策更新</h2>
        <ul>
          <li>我们可能根据法律法规变化或业务调整更新本政策。</li>
          <li>
            重大变更将通过公告、弹窗或页面提示等方式告知。更新生效后，您继续使用本服务的，视为知悉并同意更新后的内容；如您不同意，请停止使用本服务。
          </li>
        </ul>

        <h2>十、联系我们</h2>
        <ul>
          <li>
            <strong>运营方 / 个人信息处理主要责任方：</strong>
            温岭市城西宜汀餐饮店（个体工商户）；品牌：EATing创意融合轻食；联系电话：13958677072。
            负责门店自运营、餐饮服务、订单与售后等日常经营事项。
          </li>
          <li>
            <strong>开发与技术支持单位：</strong>
            温岭市太平迅驰软件开发工作室（个体工商户）；电子邮箱：wenlingxunchi@163.com。
            仅提供软件开发、系统技术支持与维护，不包含门店日常运营。
          </li>
        </ul>
      </div>
      <div class="policy-footer">
        <el-button class="btn-primary" @click="$router.push('/login')">返回登录页</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PrivacyPolicy'
}
</script>

<style scoped>
.page-wrapper {
  padding: 24px;
  min-height: 100vh;
  background: var(--page-bg);
  display: flex;
  justify-content: center;
}

.policy-card {
  max-width: 960px;
}

.policy-title {
  font-size: 20px;
  font-weight: 700;
  color: var(--text-title);
  text-align: center;
  margin-bottom: 16px;
}

.policy-content {
  font-size: 14px;
  line-height: 1.8;
  color: var(--text-body);
}

.policy-content h2 {
  font-size: 16px;
  font-weight: 600;
  color: var(--text-title);
  margin-top: 16px;
  margin-bottom: 8px;
}

.policy-content h3 {
  font-size: 15px;
  font-weight: 600;
  color: var(--text-subtitle);
  margin-top: 12px;
  margin-bottom: 4px;
}

.policy-footer {
  margin-top: 24px;
  text-align: center;
}
</style>
